<script setup lang="ts">
  import { ContainerClass } from './FormContainer.css';
</script>

<template>
  <div :class="ContainerClass"><slot /></div>
</template>
